import styled from 'styled-components';

export const StyledBase = styled.div`
  width: 100%;
  position: absolute;
  top: 600px;
  left: 0;
`;
